var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResDrivingBike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13,
    cy: 12,
    r: 12,
    fill: "#F34F42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22729_246817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 5,
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 6,
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0841 14C14.3948 14 13.834 13.4654 13.834 12.8083C13.834 12.3496 14.1071 11.9521 14.5064 11.7522L14.1569 10.9282L13.3423 12.417C13.458 12.5112 13.5319 12.6513 13.5319 12.8083C13.5319 13.0925 13.2901 13.323 12.992 13.323C12.9711 13.323 12.951 13.3215 12.9309 13.3192L12.8498 13.539C12.8329 13.5849 12.7871 13.6155 12.7365 13.6155H12.5027C12.436 13.6155 12.3822 13.5642 12.3822 13.5007C12.3822 13.4371 12.436 13.3858 12.5027 13.3858H12.6506L12.7036 13.2426C12.5855 13.1714 12.4987 13.0572 12.4666 12.9232H12.1613C12.1002 13.5267 11.566 14 10.9168 14C10.2275 14 9.66671 13.4654 9.66671 12.8083C9.66671 12.1513 10.2275 11.6167 10.9168 11.6167C11.1442 11.6167 11.3571 11.6757 11.5419 11.7775L12.0054 11.1595L11.8929 10.9428C11.803 10.9573 11.7218 10.9657 11.6608 10.9657C11.6399 10.9657 11.6206 10.965 11.6045 10.9627C11.4495 10.9428 11.3651 10.7881 11.394 10.5759C11.4262 10.3446 11.5652 10.1968 11.7315 10.216C12.624 10.3079 12.6843 10.4404 12.7068 10.4901C12.7293 10.5392 12.7221 10.5951 12.6875 10.6387C12.6088 10.739 12.3726 10.8309 12.1356 10.8914L12.2191 11.053L14.0083 10.5774L13.8605 10.2298H13.4853C13.4186 10.2298 13.3648 10.1784 13.3648 10.1149C13.3648 10.0513 13.4186 10 13.4853 10H13.9416C13.9906 10 14.0348 10.0283 14.0533 10.072L14.2815 10.6096L14.729 11.6642C14.8414 11.632 14.9604 11.6144 15.0833 11.6144C15.7726 11.6144 16.3334 12.149 16.3334 12.806C16.3334 13.4631 15.7726 13.9977 15.0833 13.9977L15.0841 14ZM11.7033 10.4442C11.6913 10.4511 11.6584 10.4878 11.6391 10.5667C11.6182 10.6533 11.6318 10.7161 11.6431 10.7352C11.7965 10.749 12.2055 10.6487 12.3983 10.5614C12.244 10.5177 11.954 10.4702 11.7033 10.4442ZM12.6923 12.8076C12.6923 12.8895 12.7293 12.9623 12.7871 13.0144L12.8779 12.7693C12.9004 12.7096 12.9687 12.6782 13.0314 12.6988C13.094 12.7203 13.127 12.7854 13.1053 12.8451L13.0145 13.0894C13.168 13.0779 13.2901 12.9562 13.2901 12.8068C13.2901 12.6498 13.1559 12.5219 12.9912 12.5219C12.8265 12.5219 12.6923 12.6498 12.6923 12.8068V12.8076ZM10.916 13.7695C11.4318 13.7695 11.8576 13.3988 11.917 12.9225H10.916C10.871 12.9225 10.8292 12.8987 10.8092 12.8604C10.7883 12.8221 10.7923 12.7762 10.818 12.741L11.4005 11.9644C11.2566 11.8893 11.0911 11.8457 10.916 11.8457C10.3592 11.8457 9.90693 12.2776 9.90693 12.8076C9.90693 13.3375 10.36 13.7695 10.916 13.7695ZM11.1506 12.6927H11.9179C11.8881 12.4584 11.77 12.25 11.5965 12.0984L11.1514 12.6927H11.1506ZM11.7371 11.9108C11.9717 12.1061 12.1291 12.3818 12.1605 12.6927H12.4658C12.4931 12.5794 12.5598 12.4798 12.6514 12.4086L12.1259 11.3923L11.7379 11.9108H11.7371ZM12.3268 11.2629L12.8667 12.3075C12.9068 12.2983 12.9478 12.2929 12.9912 12.2929C13.0386 12.2929 13.0836 12.2991 13.1278 12.3105L13.9352 10.8355L12.3276 11.2629H12.3268ZM15.0841 11.8457C14.9925 11.8457 14.9049 11.8587 14.8206 11.8801L15.1958 12.7647C15.2207 12.8237 15.1909 12.8903 15.1291 12.914C15.1146 12.9194 15.0993 12.9225 15.0841 12.9225C15.0367 12.9225 14.9917 12.8957 14.9724 12.8505L14.5972 11.9652C14.2863 12.129 14.075 12.4453 14.075 12.8068C14.075 13.3375 14.5281 13.7687 15.0841 13.7687C15.64 13.7687 16.0932 13.3368 16.0932 12.8068C16.0932 12.2769 15.64 11.8449 15.0841 11.8449V11.8457Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22729_246817",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22729_246817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22729_246817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResDrivingBike);
export default __webpack_public_path__ + "static/media/resDrivingBike.2950870d1d01618e8e7c13a4d9184e5d.svg";
export { ForwardRef as ReactComponent };